import { Button } from '@/shared/ui';
import type { FC } from 'react';

type ExportXlsxButtonProps = {
  onExport: () => void;
};

export const ExportXlsxButton: FC<ExportXlsxButtonProps> = ({ onExport }) => {
  return (
    <Button
      leftIconName="xlsx"
      className="whitespace-nowrap"
      onClick={onExport}
    >
      Export to XLSX
    </Button>
  );
};
